import { RESPONSE_SUCCESS } from '@constants'
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    let _minTime = null
    let _maxTime = null
    const maxTime = new Date(this.$taday.end).getTime()
    return {
      COM_HTTP: {}, // 请求定义
      MODULE_ROUTER: {}, // 路由定义
      selectedRows: [], // 当前选中行（复选框）
      loading: false, // 加载状态
      isShowFirst: true, // 首次加载是否请求接口
      page: {
        // 分页配置
        current: 1,
        size: 100,
        total: 0,
        sizes: [
          50,
          100,
          200,
          500,
          1000,
        ],
      },
      tableList: [], // 列表数据
      moduleName: this.$route.name,
      IdKey: 'id', // 键名
      dialogWidth: '', // 弹窗宽度
      rowData: {},
      keyBtn: false,
      isRowDetailUrl: true, // 是否有查看详情的接口，没有则用列表行
      editDialogVisible: false, // 编辑.新增弹窗是否显示
      viewDialogVisible: false, // 查看弹窗是否显示
      delTitObj: {
        title: this.$lang('删除订单'),
        subTitle: this.$lang('你确定要删除已选中的订单吗？'),
        threeTitle: '',
      },
      pickerOptions: {
        disabledDate (time) {
          if (_minTime && _maxTime) {
            return time.getTime() < _minTime || time.getTime() > _maxTime
          }
          return time.getTime() > maxTime
        },
        onPick ({ maxDate, minDate }) {
          // 如果选择了只选择了一个时间
          if (!maxDate) {
            const timeRange = 29 * 24 * 60 * 60 * 1000 // 30天
            _minTime = minDate.getTime() - timeRange // 最小时间
            _maxTime = minDate.getTime() + timeRange > new Date() ? maxTime : minDate.getTime() + timeRange// 最大时间
            // 如果选了两个时间，那就清空本次范围判断数据，以备重选
          } else {
            _minTime = _maxTime = null
          }
        },
      },
    }
  },

  watch: {
    '$route'() {
      clearTimeout(this.searchFunTime)
      this.loading = false
    },
  },
  // 缓存组件-进入页面的钩子
  activated() {
    // 如果定时器存在，则重新请求列表
    if (this.searchFunTime) {
      this.searchFun()
    }
  },

  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  mounted() {
    if (this.isShowFirst) {
      this.$nextTick().then(res => {
        this.searchFun()
      })
    }
  },
  created() {
    // this.initMixinParams()
    this.addListener()
  },
  methods: {
    ...mapActions(['SET_SELECTED_ID']),
    // // 初始化mixin的参数
    // initMixinParams() {
    //   this.canUsePrevListParam = false // 是否记录列表的表单参数
    //   this.prevListParams = {} // 前一次搜索组件的表单参数
    // },
    // 单选操作（复选框）
    selectionChange(val) {
      this.selectedRows = val
    },
    // 新增
    rowAdd() {
      this.fromType = 'addRouter'
      this.editDialogVisible = true
    },
    // 编辑
    rowEdit(row) {
      this.fromType = 'editRouter'
      this.editDialogVisible = true
      this.viewFun(row)
    },
    // 表单保存前
    beforeSubmit() {},
    // 表单保存(关闭弹窗)
    handleSubmit(formName, type) {
      // 提交前数据处理
      const params = this.beforeSubmit()
      // 验证请求
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.fromType === 'editRouter') {
            // 编辑保存
            this.submitForm('reqUpdate', params)
          } else {
            // 新增保存
            this.submitForm('reqAdd', params)
          }
        } else {
          return false
        }
      })
    },
    // 提交请求（自己本地写）
    async submitForm(reqType, updateParams) {
      let res = {}
      this.keyBtn = true
      res = await this.COM_HTTP[reqType](updateParams)
      this.keyBtn = false
      if (res.code !== RESPONSE_SUCCESS) {
        this.$message.warning(res.msg)
        return
      }
      this.handleClose()
      setTimeout(() => {
        this.searchFun()
      }, 300)
      this.$message.success(this.$lang('保存成功'))
    },
    // 弹窗关闭前
    beforehandleClose() {},
    // 表单关闭（关闭弹窗）
    handleClose(formName) {
      this.beforehandleClose()
      this.editDialogVisible = false
      // 清除rowData数据
      this.clearFormItem()
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields()
      }
    },
    // 查看
    async rowView(row) {
      // 获取查看详情
      await this.viewFun(row)
      this.viewDialogVisible = true
    },
    // 查看方法
    async viewFun(row, params) {
      if (this.isRowDetailUrl) {
        const { data, code, msg } = await this.COM_HTTP.reqDetail(params || { id: row.id })
        if (code === RESPONSE_SUCCESS) {
          // 回显数据
          const newRow = this.handleData(data)
          this.rowData = Object.assign({}, { ...newRow })
        } else {
          this.$message.error(msg)
        }
      } else {
        // 回显数据
        this.rowData = this.handleData(row)
      }
    },
    // 重新处理字段不一的查看字段
    handleData(row) {
      return { ...row }
    },
    // 删除提示弹窗
    async rowDel(row, index) {
      this.$confirm(
        `
      <div class="comfirm-wrap">
        <i class="el-icon-warning"></i>
        <h3 class="comfirm-hd">${this.delTitObj.title}</h3>
      </div>
      <p class="comfirm-tit">${this.delTitObj.subTitle}</p>
      <p class="comfirm-tit sub-tit">${this.delTitObj.threeTitle}</p>
      `,
        '',
        {
          confirmButtonText: this.$lang('确定'),
          cancelButtonText: this.$lang('取消'),
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          customClass: 'comfirm-box',
          confirmButtonClass: 'h88',
          cancelButtonClass: 'h88 cancelBtn',
        }
      )
        .then(() => {
          this.deleteFun(row)
        })
        .catch(_ => {})
    },
    // 删除方法
    async deleteFun(item) {
      const res = await this.COM_HTTP.reqDel(item)
      if (res.code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('删除成功'))
        this.afterDelSuccess()
      } else {
        this.$message.error(res.msg)
      }
    },
    // 删除成功后回调
    afterDelSuccess() {
      setTimeout(() => {
        this.searchFun()
      }, 300)
    },
    // 触发按钮查询
    searchChange(params) {
      this.searchFun(1)
    },
    // 查询参数；可自己覆盖
    getParams() {
      return {}
    },
    // 查询方法
    async searchFun(current) {
      let searchFunTime = null
      clearTimeout(searchFunTime)
      this.loading = true
      // 重置表格滚动条置顶
      if (this.$refs.table) {
        this.$refs.table.$el.querySelector('.el-table__body-wrapper').scrollTop = 0
      }
      // 传入参数有current
      if (current) {
        this.page.current = current
      }
      // 获取定时器ID
      searchFunTime = setTimeout(async () => {
        // 清空定时器ID
        this.searchFunTime = null
        if (typeof this.searchFunBefore === 'function') {
          const state = this.searchFunBefore()
          if (!state) {
            this.loading = false
            return
          }
        }
        // 添加超时清除loading状态的定时器
        const timeState = setTimeout(() => {
          if (this.loading) this.loading = false
        }, 15000)
        const newParams = Object.assign({ current: this.page.current, size: this.page.size }, this.getParams())
        console.log(newParams, 'newParams')
        const res = await this.COM_HTTP.reqList(newParams)
        // 清除超时定时器
        clearTimeout(timeState)
        this.loading = false
        if (res.code === RESPONSE_SUCCESS) {
          this.tableList = res.data.records ? (this.formatList ? this.formatList(res.data) : res.data.records) : []
          this.page.total = res.data.total || 0
          this.page.current = res.data.current || 1
        } else {
          this.$message.error(res.msg)
        }
      }, 1000)
    },
    // 获取导出方法参数
    getParamForOutExcel() {
      return {}
    },
    // 导出方法
    async outExcel() {
      // 获取参数
      const param = this.getParamForOutExcel()
      // 启用加载中状态
      this.loading = true
      // console.log('outExcel::params', param)
      // 调用导出api
      const res = await this.COM_HTTP.reqExcel(param)
      // 关闭加载中状态
      this.loading = false
      // 如果有返回体
      if (res) {
        const enc = new TextDecoder('utf-8')
        let errorData = { code: null }
        try {
          errorData = JSON.parse(enc.decode(new Uint8Array(res))) // 转化成json对象
        } catch (error) {
          // errorData.code = null
        }
        // 提示异常
        if (errorData.code) {
          this.$message.error(errorData.msg)
        } else {
          // 根据当前路由设置确定文件名
          const filename = this.$lang(this.$route.meta.title) + '.xls'
          // 兼容IE的写法
          if (!!window.ActiveXObject || 'ActiveXObject' in window) {
            window.navigator.msSaveOrOpenBlob(res, filename)
          } else {
            // 现代浏览器通用写法
            // 返回的数据已经是blob对象，所以无需使用new Blob([res])进行再次转换，直接创建url
            const url = window.URL.createObjectURL(new Blob([res]))
            // 创建a标签
            const elink = document.createElement('a')
            // 设置a标签隐藏
            elink.style.display = 'none'
            // 设置a标签的链接属性为url
            elink.href = url
            // 给a标签添加下载属性download （重要）
            elink.setAttribute('download', filename)
            // 添加a标签到文档节点
            document.body.appendChild(elink)
            // 触发a标签点击
            elink.click()
            // 释放URL对象
            URL.revokeObjectURL(elink.href)
            // 移除刚穿件的a标签
            document.body.removeChild(elink)
          }
        }
      }
    },
    // 选择分页条数
    sizeChange(val) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.searchFun()
    },
    // 重置搜索
    resetSearch() {
      this.page.current = 1
      this.searchParam = '' || {}
    },
    refreshList() {
      this.page.current = 1
      this.searchFun()
    },
    /*
     *@Description: 订阅更新列表的事件
     *@param {arg} type
     *@return [type]
     *@Date: 2019-07-25 20:53:53
     */
    addListener() {
      this.$bus.$on('submit-success', name => {
        if (this.moduleName === name) {
          this.refreshList()
        }
      })
    },
  },
  /*
   *@Description: 取消订阅事件
   *@param {arg} type
   *@return [type]
   *@Date: 2019-07-25 21:09:54
   */
  destroyed() {
    this.$bus.$off('submit-success')
  },
}
